import { render, staticRenderFns } from "./SeniorMenu.vue?vue&type=template&id=327a991d&scoped=true&"
import script from "./SeniorMenu.vue?vue&type=script&lang=js&"
export * from "./SeniorMenu.vue?vue&type=script&lang=js&"
import style0 from "./SeniorMenu.vue?vue&type=style&index=0&id=327a991d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a991d",
  null
  
)

export default component.exports